import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import Illustration from "../../../../../partials/content/Illustration";
import {
  cancelItemRequest,
  getItemsRequest,
} from "../../../../../services/inventory/itemReservationService";
import ItemsRequestForm from "./itemsRequestForm";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { Badge } from "react-bootstrap";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
function OutletItemsRequest({ outletID: outletIDprop = 0, match }) {
  const { reload } = useGlobalData();
  const [outlet, setOutlet] = useState({ ID: 0, outletName: "" });
  const [itemsRequest, setItemsRequest] = useState([]);
  const [openItemsRequestForm, setOpenItemsRequestForm] = useState(false);
  let outletID = 0;
  outletID = outletIDprop;
  if (outletID === 0) {
    const { outletID: outletIDparam = 0 } = match.params;
    outletID = outletIDparam;
  }
  useEffect(() => {
    getItemsRequestData(outletID);
  }, [outletID, reload]);

  async function getItemsRequestData(outletID) {
    const response = await getItemsRequest(0, 0, 0, outletID);
    const { data } = response.data;
    setItemsRequest(data.itemsRequest);
    setOutlet(data.outlet);
  }

  const outletRequestDetailColumn = [
    {
      header: "Sales Pos ID",
      field: "salesPosID",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];
  return (
    <React.Fragment>
      {itemsRequest.length ? (
        <React.Fragment>
          <CustomDataTable
            data={itemsRequest}
            dataDetailColumns={outletRequestDetailColumn}
            onRefreshData={() => {
              getItemsRequestData(outletID);
            }}
            buttons={[
              {
                name: "New Items Request",
                onClick: () => {
                  setOpenItemsRequestForm(true);
                },
                icon: "fas fa-plus-circle",
                color: "primary",
              },
            ]}
            dataDetailTitle="Reserved"
            columns={[
              {
                header: "Item Request ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Warehouse Name",
                field: "warehouse.warehouseName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.warehouse.warehouseName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Item Type",
                field: "itemTypeName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.itemTypeName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Item Code",
                field: "itemCode",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.itemType > 0 ? (
                      <span>
                        <BootstrapTooltip title={rowData.itemTypeName}>
                          <span className="mr-2">
                            <i
                              className={
                                rowData.itemType === 1
                                  ? "fas fa-boxes text-success"
                                  : rowData.itemType === 2
                                  ? "fas fa-tools text-primary"
                                  : rowData.itemType === 3
                                  ? "fas fa-building text-info"
                                  : rowData.itemType === 4
                                  ? "fas fa-boxes text-warning"
                                  : rowData.itemType === 5
                                  ? "fas fa-boxes text-danger"
                                  : null
                              }
                            ></i>
                          </span>
                        </BootstrapTooltip>
                        <span>
                          <ResponsiveEllipsis
                            text={rowData.itemCode}
                            maxLine="1"
                            displayInline
                          />
                        </span>
                      </span>
                    ) : (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.itemCode}
                          maxLine="1"
                        />
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Item Name",
                field: "itemName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Goods Receive Status",
                field: "statusName",
                body: (rowData) => {
                  if (rowData.statusID === 1) {
                    return <Badge variant="danger">{rowData.statusName}</Badge>;
                  } else if (rowData.statusID === 2) {
                    return (
                      <Badge variant="warning">{rowData.statusName}</Badge>
                    );
                  } else if (rowData.statusID === 3) {
                    return (
                      <Badge variant="success">{rowData.statusName}</Badge>
                    );
                  } else {
                    return <Badge variant="dark">{rowData.statusName}</Badge>;
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Quantity",
                field: "qty",
                body: (rowData) => (
                  <div>
                    {rowData.qty} {rowData.uom.uomName}
                  </div>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Unit",
                field: "uom.uomName",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.statusID === 1 ? (
                      <BootstrapTooltip title="Delete Items Request">
                        <button
                          type="button"
                          onClick={() => {
                            cancelRequest(rowData);
                          }}
                          className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Inventory.png"
            description="Hooray! You're ready to have your first Items Request from this outlet!"
            guidance="Hint: manage your items request to the warehouses to maximize collaboration"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                setOpenItemsRequestForm(true);
              }}
            >
              <i className="fas fa-plus-circle"></i>
              New Items Request
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openItemsRequestForm}
        title="Items Request Form"
        onCloseDialog={() => {
          setOpenItemsRequestForm(false);
        }}
      >
        <ItemsRequestForm
          outletID={outletID}
          outletName={outlet.outletName}
          onCloseDialog={() => {
            setOpenItemsRequestForm(false);
          }}
          onConfirmSave={() => {
            getItemsRequestData(outletID);
            setOpenItemsRequestForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function cancelRequest(rowData) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Items Request ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelItemRequest(rowData.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getItemsRequestData(0, 0, outletID);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }
}

export default OutletItemsRequest;
